import {
  ArrowForwardIos,
  ContentCopy,
  Delete,
  CloudUpload,
  Description,
} from "@mui/icons-material";
import React, { memo, useState } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";
import { Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();
  const [isHovered, setIsHovered] = useState(false);
  const theme = useTheme();

  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        backgroundColor: theme.palette.type === 'dark' ? "#262626" : "#ffffff",
        padding: "20px",
        borderRadius: "16px",
        minWidth: "280px",
        maxWidth: "280px",
        width: "280px",
        position: "relative",
        fontFamily: "'Inter', sans-serif",
        border: `2px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.12)" : "#e5e7eb"}`,
        boxShadow: isHovered 
          ? "0 12px 32px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(99, 102, 241, 0.1)"
          : "0 4px 16px rgba(0, 0, 0, 0.06)",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        transform: isHovered ? "translateY(-2px)" : "translateY(0px)",
        pointerEvents: "auto",
        userSelect: "none",
      }}
    >
      {/* Target Handle */}
      <Handle
        type="target"
        position="left"
        style={{
          background: "linear-gradient(135deg, #6366f1, #4f46e5)",
          width: "16px",
          height: "16px",
          top: "24px",
          left: "-10px",
          cursor: 'pointer',
          border: `3px solid ${theme.palette.type === 'dark' ? "#262626" : "#ffffff"}`,
          boxShadow: "0 2px 8px rgba(99, 102, 241, 0.3)",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
        onConnect={params => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "8px",
            height: "8px",
            marginLeft: "2.5px",
            marginBottom: "0.5px",
            pointerEvents: "none"
          }}
        />
      </Handle>

      {/* Action Buttons */}
      <div
        style={{
          display: "flex",
          position: "absolute",
          right: "16px",
          top: "16px",
          cursor: "pointer",
          gap: "8px",
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "#444444" : "#e5e7eb";
            e.target.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "#333333" : "#f3f4f6";
            e.target.style.transform = "scale(1)";
          }}
        >
          <ContentCopy
            sx={{ 
              width: "14px", 
              height: "14px", 
              color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280"
            }}
          />
        </div>
        <div
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            backgroundColor: theme.palette.type === 'dark' ? "rgba(239, 68, 68, 0.1)" : "#fef2f2",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "rgba(239, 68, 68, 0.2)" : "#fee2e2";
            e.target.style.transform = "scale(1.1)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = theme.palette.type === 'dark' ? "rgba(239, 68, 68, 0.1)" : "#fef2f2";
            e.target.style.transform = "scale(1)";
          }}
        >
          <Delete
            sx={{ 
              width: "14px", 
              height: "14px", 
              color: "#ef4444"
            }}
          />
        </div>
      </div>

      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "16px",
          paddingBottom: "12px",
          borderBottom: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "#f3f4f6"}`,
        }}
      >
        <div
          style={{
            width: "36px",
            height: "36px",
            borderRadius: "10px",
            background: "linear-gradient(135deg, #6366f1, #4f46e5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "12px",
            boxShadow: "0 4px 12px rgba(99, 102, 241, 0.25)",
          }}
        >
          <CloudUpload
            sx={{
              width: "18px",
              height: "18px",
              color: "#ffffff",
            }}
          />
        </div>
        <div>
          <div 
            style={{ 
              color: theme.palette.type === 'dark' ? "#ffffff" : "#111827", 
              fontSize: "16px", 
              fontWeight: "700",
              lineHeight: "1.2",
              marginBottom: "2px",
            }}
          >
            Arquivo
          </div>
          <div 
            style={{ 
              color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280", 
              fontSize: "12px", 
              fontWeight: "500",
            }}
          >
            Upload de documento
          </div>
        </div>
      </div>

      {/* File Content */}
      <div
        style={{
          backgroundColor: theme.palette.type === 'dark' ? "#333333" : "#f9fafb",
          padding: "16px",
          borderRadius: "12px",
          border: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "#f3f4f6"}`,
          marginBottom: "16px",
          textAlign: "center",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            borderRadius: "12px",
            background: theme.palette.type === 'dark' ? "linear-gradient(135deg, #1e1e1e, #333333)" : "linear-gradient(135deg, #e0e7ff, #c7d2fe)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 12px auto",
          }}
        >
          <Description
            sx={{
              width: "24px",
              height: "24px",
              color: "#6366f1",
            }}
          />
        </div>
        <div 
          style={{
            fontSize: "14px",
            fontWeight: "600",
            color: theme.palette.type === 'dark' ? "#ffffff" : "#111827",
            marginBottom: "4px",
          }}
        >
          {data.label || "Enviar Arquivo"}
        </div>
        {data.file && (
          <Typography 
            variant="body2" 
            style={{
              color: theme.palette.type === 'dark' ? "#9ca3af" : "#6b7280",
              fontSize: "12px",
              fontWeight: "400",
              marginTop: "4px",
            }}
          >
            Arquivo: {data.file.name}
          </Typography>
        )}
      </div>

      {/* Footer Info */}
      <div
        style={{
          paddingTop: "12px",
          borderTop: `1px solid ${theme.palette.type === 'dark' ? "rgba(255, 255, 255, 0.08)" : "# f3f4f6"}`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            fontSize: "11px",
            color: "#9ca3af",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
          }}
        >
          <CloudUpload sx={{ width: "12px", height: "12px", marginRight: "4px" }} />
          Componente Arquivo
        </div>
      </div>

      {/* Source Handle */}
      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "linear-gradient(135deg, #6366f1, #4f46e5)",
          width: "16px",
          height: "16px",
          right: "-10px",
          top: "50%",
          cursor: 'pointer',
          border: `3px solid ${theme.palette.type === 'dark' ? "#262626" : "#ffffff"}`,
          boxShadow: "0 2px 8px rgba(99, 102, 241, 0.3)",
          transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
        }}
        isConnectable={isConnectable}
      >
        <ArrowForwardIos
          sx={{
            color: "#ffffff",
            width: "8px",
            height: "8px",
            marginLeft: "2px",
            marginBottom: "0.5px",
            pointerEvents: "none"
          }}
        />
      </Handle>
    </div>
  );
});